import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelOffboard } from '../api/userManagementApi';
import { userKeys } from './userKeys';

export const useCancelOffboard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => cancelOffboard(userId),

    onSuccess: (_, userId) => {
      queryClient.invalidateQueries({
        queryKey: userKeys.detail(userId),
      });
      queryClient.invalidateQueries({ queryKey: userKeys.lists() });
    },
  });
};
